import { render, staticRenderFns } from "./SaasStatisticsView.vue?vue&type=template&id=4895db48"
import script from "./SaasStatisticsView.vue?vue&type=script&lang=js"
export * from "./SaasStatisticsView.vue?vue&type=script&lang=js"
import style0 from "./SaasStatisticsView.vue?vue&type=style&index=0&id=4895db48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports